import React, { useEffect, useState } from 'react';
import { FileProps, FileData } from './types';
import {
    CloseWrapper,
    DisableCover,
    IconWrapper,
    TextWrapper,
    Content,
    Wrapper,
    PreloaderWrapper,
} from './file.styles';
import { Typography } from '@shared/ui/typography/typography';
import { AllClose, AllDownload } from '@vtbhome/juicyfront/indexIcon';
import { fileFormatBytes } from '@shared/lib/utils/file-format-bytes/file-format-bytes';
import { parseFileUrl } from '@shared/lib/utils/parse-file-url/parse-file-url';
import { CLOSE_SIZE } from './contants';
import { Preloader } from '@vtbhome/juicyfront';
import { IMAGE_EXTENSIONS } from '@shared/config/file/image-extensions';
import { FileIcon } from '../file-icon/file-icon';

export const File: React.FC<FileProps> = ({
    dimension = 'l',
    localFile,
    uploadedFile,
    error,
    isLoading,
    disabled,
    onRemove,
    onSave,
    className,
}) => {
    const [fileData, setFileData] = useState<FileData | null>(null);

    useEffect(() => {
        if (uploadedFile) {
            const extension = uploadedFile.extension;
            const fileSize = uploadedFile?.size;
            const isImage = extension && IMAGE_EXTENSIONS.includes(extension);
            setFileData({
                imageUrl: isImage ? uploadedFile.url : undefined,
                name: uploadedFile.name,
                size: fileSize ? fileFormatBytes(fileSize) : undefined,
                extension,
            });
        } else if (localFile) {
            const isImage = localFile.base64.includes('image');
            const parsedFileName = parseFileUrl(localFile.file.name);
            setFileData({
                extension: parsedFileName.fileExtension || '',
                imageUrl: isImage ? localFile.base64 : undefined,
                name: parsedFileName.fileName || '',
                size: fileFormatBytes(localFile.file.size),
            });
        }
    }, []);

    if (!fileData) {
        return null;
    }

    return (
        <Wrapper className={className}>
            <Content dimension={dimension} isError={Boolean(error)} disabled={disabled}>
                <IconWrapper dimension={dimension}>
                    <FileIcon dimension={dimension} file={fileData} />
                </IconWrapper>
                <TextWrapper dimension={dimension}>
                    {fileData.name && (
                        <Typography size='body2_long'>
                            {fileData.name}.{fileData.extension}
                        </Typography>
                    )}
                    {fileData.size && (
                        <Typography size='caption1' color='neutral_50'>
                            {fileData.size}
                        </Typography>
                    )}
                </TextWrapper>
                {isLoading && (
                    <PreloaderWrapper>
                        <Preloader size='m' />
                    </PreloaderWrapper>
                )}
                {onRemove && (
                    <CloseWrapper disabled={disabled} onClick={disabled ? undefined : onRemove}>
                        <AllClose size={CLOSE_SIZE[dimension]} />
                    </CloseWrapper>
                )}
                {onSave && (
                    <CloseWrapper disabled={disabled} onClick={disabled ? undefined : onSave}>
                        <AllDownload size={CLOSE_SIZE[dimension]} />
                    </CloseWrapper>
                )}
                {disabled && <DisableCover />}
            </Content>
            {Boolean(error) && (
                <Typography size='body2_short' color='error_60'>
                    {error}
                </Typography>
            )}
        </Wrapper>
    );
};
